export { useTheme, type ResolvedColorScheme } from "#use-theme";
